import { render, staticRenderFns } from "./CalculatorResourceModal.vue?vue&type=template&id=33d7a74b&"
import script from "./CalculatorResourceModal.vue?vue&type=script&lang=js&"
export * from "./CalculatorResourceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports